export interface AiWorkspaceSuggestions {
  industry: string;
  lifecycle_names: { [systemKey: string]: string };
  call_outcomes: AiCallOutcome[];
  visit_outcomes: AiVisitOutcome[];
  deal_stages: AiDealStage[];
  products: AiProduct[];
  custom_contact_properties: AiContactProperty[];
  work_pipeline_items: AiWorkPipelineItem[];
}

export interface AiCallOutcome {
  name: string;
  value?: string;
  nature: 'positive' | 'negative' | 'neutral';
  startsNewDeal?: boolean;
  junkLead?: boolean;
  selected?: boolean;
}

export interface AiVisitOutcome {
  name: string;
  value?: string;
  nature: 'positive' | 'negative' | 'neutral';
  startsNewDeal?: boolean;
  selected?: boolean;
}

export interface AiDealStage {
  name: string;
  value?: string;
  description: string;
  isTerminalSuccess?: boolean;
  isTerminalFailure?: boolean;
  selected?: boolean;
}

export interface AiProduct {
  name: string;
  type: 'PRODUCT' | 'SERVICE';
  category?: string;
  price?: number;
  selected?: boolean;
}

export interface AiContactProperty {
  name: string;
  fieldName?: string;
  type: 'Text' | 'Number' | 'Option' | 'DateTime';
  options?: string[];
  selected?: boolean;
}

export interface AiWorkPipelineItem {
  title: string;
  actionLabel: string;
  priority: number;
  description?: string;
  selected?: boolean;
}

export interface WizardStepState {
  completed: boolean;
  skipped: boolean;
}

export interface WizardStepConfig {
  key: string;
  label: string;
  icon: string;
  skippable: boolean;
}

export const WIZARD_STEPS: WizardStepConfig[] = [
  { key: 'account', label: 'Organization', icon: 'bi-building', skippable: false },
  { key: 'callOutcomes', label: 'Call Outcomes', icon: 'bi-telephone', skippable: true },
  { key: 'visitOutcomes', label: 'Visit Outcomes', icon: 'bi-geo-alt', skippable: true },
  { key: 'form', label: 'Qualification Form', icon: 'bi-ui-checks', skippable: true },
  { key: 'dealStages', label: 'Deal Stages', icon: 'bi-funnel', skippable: true },
  { key: 'products', label: 'Products & Services', icon: 'bi-box', skippable: true },
  { key: 'team', label: 'Invite 3 Sales Reps', icon: 'bi-people', skippable: true },
  { key: 'leads', label: 'Add Initial Leads', icon: 'bi-person-plus', skippable: true },
  { key: 'finish', label: 'Finish', icon: 'bi-check-circle', skippable: false },
];
